import { OnInit, OnDestroy } from '@angular/core';
import { OrderService } from "../../shared/services/order.service";
import { ShoppingService } from 'app/shared/services/shopping.service';
import { Router } from '@angular/router';
import { AlertService } from 'app/shared/services/alert.service';
var CheckoutThankyouComponent = /** @class */ (function () {
    function CheckoutThankyouComponent(orderService, shoppingService, router, alertService) {
        this.orderService = orderService;
        this.shoppingService = shoppingService;
        this.router = router;
        this.alertService = alertService;
        this._hasLoadedOrder = false;
        this._hasFinishedSingleOrderSetup = false;
    }
    CheckoutThankyouComponent.prototype.ngOnDestroy = function () {
        if (this.isSingleCheckoutOrder) {
            this.shoppingService.endSingleItemCheckout();
        }
    };
    CheckoutThankyouComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.orderService.getLastOrder().then(function (order) {
            _this._hasLoadedOrder = true;
            _this._order = order;
        })
            .catch(function (error) {
            console.error(error);
            _this._hasLoadedOrder = true;
        });
        // TODO: stephen this is very hacky... but we will do it for now until we can re-arrange the assessment integration
        if (this.isSingleCheckoutOrder) {
            var assignmentCompleteAlerts_1 = setInterval(function () {
                if (_this.alertService.getAlertCount() <= 0) {
                    clearInterval(assignmentCompleteAlerts_1);
                    _this._hasFinishedSingleOrderSetup = true;
                }
            }, 250);
        }
    };
    Object.defineProperty(CheckoutThankyouComponent.prototype, "order", {
        get: function () {
            return this._order;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutThankyouComponent.prototype, "isSingleCheckoutOrder", {
        get: function () {
            return this.shoppingService.isSingleCheckoutOrder();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutThankyouComponent.prototype, "hasFinishedSingleOrderSetup", {
        get: function () {
            return this._hasFinishedSingleOrderSetup;
        },
        enumerable: true,
        configurable: true
    });
    CheckoutThankyouComponent.prototype.returnFromOrder = function () {
        var returnUrl = this.shoppingService.getSingleItemCheckoutReturnUrl();
        this.router.navigateByUrl(returnUrl);
    };
    Object.defineProperty(CheckoutThankyouComponent.prototype, "hasLoadedOrder", {
        get: function () {
            return this._hasLoadedOrder;
        },
        enumerable: true,
        configurable: true
    });
    return CheckoutThankyouComponent;
}());
export { CheckoutThankyouComponent };



// WEBPACK FOOTER //
// ./src/app/admin/checkout-thankyou/checkout-thankyou.component.ts.pre-build-optimizer.js